import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-purge-management',
  templateUrl: './purge-management.component.html',
  styleUrl: './purge-management.component.css'
})
export class PurgeManagementComponent {

  constructor(public _restAPI: RestAPIService, private toast: ToastService, public dialogRef: MatDialogRef<PurgeManagementComponent>){
    this._restAPI.loading  = false;
  }

  purgeCache() {
    this._restAPI.loading  = true;
    this._restAPI.post<string>(environment.apiURL + 'api/cache/purge', null).subscribe({
        next: (results) => {
          this._restAPI.loading  = false;
          this.dialogRef.close(true);
          this.toast.show("Purge request accept. System will purge Cache in background.");
        },
        error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
    });
  }
  closeDialog(): void {
    this.dialogRef.close(false);
  }
}
